import React from 'react';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import moment from 'moment';
import { familyDetailsHeaders } from './constants';

function ViewTravellerInfoModal({ isOpen, toggle, data }) {
  const renderFamilyDetails = () => {
    if ((data && data?.length < 0) || !data || data?.length === 0) {
      return (
        <tr>
          <td colSpan={familyDetailsHeaders.length} className="text-center">
            No traveller information available.
          </td>
        </tr>
      );
    }

    return data?.map((familyMember, index) => (
      <tr key={index}>
        <td className="text-center">{familyMember?.Traveler_FName}</td>
        <td className="text-center">{familyMember?.Traveler_MName}</td>
        <td className="text-center">{familyMember?.Traveler_LName}</td>
        <td className="text-center">
          <td>{moment(familyMember?.DOB).format('LL')}</td>
        </td>
        <td className="text-center">{familyMember?.PassportNo}</td>
        <td className="text-center">{familyMember?.Relationship}</td>
      </tr>
    ));
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="view-traveller-info-modal"
      size="xl"
      centered
    >
      <ModalHeader toggle={toggle} className="mb-3">
        View Traveller Information
      </ModalHeader>
      <ModalBody className="">
        <div
          className="table-responsive"
          style={{
            border: '2px solid #D0D5DD',
            borderRadius: '8px',
          }}
        >
          <Table className="custom-table mb-0">
            <thead>
              <tr>
                {familyDetailsHeaders.map((header, index) => (
                  <th key={index} className="text-center">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{renderFamilyDetails()}</tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ViewTravellerInfoModal;
